import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { LegalPage } from '../components/LegalPage.tsx';
import { privacyDocs } from '../content/legal/index.ts';
import { useRouteMeta } from '../lib/useDocumentMeta.ts';
import type { Locale } from '../intl/index.ts';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  useRouteMeta('meta.privacy.title', 'meta.privacy.description');
  const { locale } = useIntl();
  const doc = privacyDocs[locale as Locale] ?? privacyDocs.en;
  return <LegalPage doc={doc} />;
}
